import { search } from '@wix/ambassador-metasite-search-v2-search-entry/http'
import { MetaSiteSearchEntry, Namespace } from '@wix/ambassador-metasite-search-v2-search-entry/types'
import { tryCatch } from '@wix/funnel-utils'
import { useCallback, useEffect, useState } from 'react'

import { ambassadorHttpClient } from '../../api/httpClient'

type State = { type: 'loading' } | { type: 'error'; error: Error } | { type: 'ready'; metaSites: MetaSiteSearchEntry[] }

export const useLoadMetaSites = () => {
  const [state, setState] = useState<State>({ type: 'loading' })

  const reload = useCallback(async () => {
    setState({ type: 'loading' })
    const request = search({
      paging: {
        pageSize: 100,
      },
      responseData: ['name', 'siteProperties', 'ownerId', 'apps'],
      filters: {
        namespaceFilter: {
          multi: {
            namespaces: [Namespace.WIX, Namespace.DASHBOARD_FIRST, Namespace.ANYWHERE],
          },
        },
      },
    })
    const promise = ambassadorHttpClient.request(request).then(({ data }) => data.entries || [])
    const [error, metaSites] = await tryCatch(() => promise)
    if (error) {
      return setState({ type: 'error', error })
    }
    return setState({ type: 'ready', metaSites })
  }, [])

  useEffect(() => {
    void reload()
  }, [reload])

  return [state, reload] as const
}
